module.exports = __webpack_public_path__ + "assets/layers.png?a6137456ed160d7606981aa57c559898";